/* @ngInject */
function timesheetTimeFilter () {
  return function (time) { // Example: 12:00:00+00
    if (!time) {
      return ''
    }

    const [hours, minutes] = time.split(':')
    return `${hours}:${minutes}`
  }
}

export { timesheetTimeFilter }
